import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  icon,
  children
}: PageHeaderProps) {
  return <div className="relative bg-white rounded-2xl border border-slate-200/60 shadow-[0_1px_3px_rgba(0,0,0,0.04)] overflow-hidden animate-slide-up mb-6" data-id="element-220">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-[#eef2fc]/30 to-[#d5e0f7]/20 pointer-events-none" data-id="element-221" />

      <div className="relative p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-222">
        <div className="flex items-center gap-4" data-id="element-223">
          <div className="p-3 bg-[#2952C4] text-white rounded-xl shadow-sm flex-shrink-0" data-id="element-224">
            {icon}
          </div>
          <div data-id="element-225">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 font-heading tracking-tight" data-id="element-226">
              {title}
            </h2>
            {subtitle && <p className="text-sm text-slate-500 mt-0.5 font-medium" data-id="element-227">
                {subtitle}
              </p>}
          </div>
        </div>

        {children && <div className="flex items-center gap-3" data-id="element-228">{children}</div>}
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#2952C4] via-[#5483df] to-transparent opacity-80" data-id="element-229" />
    </div>;
}